import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import ImageCarousel from "@/components/ImageCarousel";





const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "erm-media",
    "url": "https://erm-media.com",
    "logo": "https://erm-media.com/logo.png",
    "description": "Desarrollo de proyectos informáticos: landing pages, optimización SEO, sistemas en Laravel PHP, Python y análisis de requerimientos.",
    "address": {
      "@type": "Comunidad de Madrid",
      "addressCountry": "ES"
    },
    "sameAs": [
        "https://x.com/ermmedia"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": ["Spanish", "English"]
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Proyectos Informáticos a Medida | Desarrollo Web, SEO, Laravel, Python | Inteligencia Artificial | WordPress | Drupal | ODOO"
        description="Desarrollo de proyectos informáticos: landing pages, optimización SEO, sistemas en Laravel PHP, Python y análisis de requerimientos. Soluciones digitales profesionales."
        keywords="desarrollo web, landing pages, SEO, Laravel, Symfony, PHP, Python, Oddo, proyectos informáticos, análisis de requerimientos, desarrollo software, inteligencia artificial, soluciones digitales, empresa de desarrollo y servicios informáticos"
        canonicalUrl="https://erm-media.com"
        structuredData={structuredData}
      />
      <Header />
      <main className="pt-16">
        <HeroSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
